import React from 'react';
import JuniperVideo from './JuniperVideo';
import ClientBuildVisual from './ClientBuildVisual';
import { Link } from 'react-router-dom';
import '../styles/character-preview.css';

const CustomBuilds: React.FC = () => (
  <section id="built" className="band custom-builds" aria-labelledby="custom-builds-title">
    <div className="shell">
      <div className="lede-row">
        <h2 className="h2" id="custom-builds-title">Custom software for your business.</h2>
        <p>Inventory systems, point-of-sale workflows and customer apps, designed around how your team works. These windows are illustrative prototypes, not client data.</p>
      </div>

      <div className="client-builds" role="region" aria-label="Client prototypes" tabIndex={0}>
        <article className="client-build"><span className="client-build__type">Client prototype · 01 <i>· illustrative</i></span><ClientBuildVisual kind="inventory" /><h3>Inventory workflow</h3><p>A stock view designed around what the team needs to reorder and prepare.</p></article>
        <article className="client-build"><span className="client-build__type">Client prototype · 02 <i>· illustrative</i></span><ClientBuildVisual kind="register" /><h3>Ordering + register</h3><p>A staff-facing order flow shaped for the client’s counter operation.</p></article>
        <article className="client-build"><span className="client-build__type">Client prototype · 03 <i>· illustrative</i></span><ClientBuildVisual kind="app" /><h3>Customer app</h3><p>An order-ahead experience tailored to how customers actually buy.</p></article>
      </div>
      <div className="custom-builds__cta"><Link className="link" to="/contact">Talk to us about a custom build <span aria-hidden="true">↗</span></Link></div>

      <div className="custom-builds__more"><h3>We also build around the work.</h3><p>Software can extend into a dedicated AI assistant or connected devices when the workflow calls for it.</p></div>
      <div className="build-cards build-cards--two">
        <article className="build-card">
          <div className="build-card__visual"><JuniperVideo /></div>
          <div className="build-card__body">
            <h3>Custom AI employees</h3>
            <p>A dedicated colleague for ongoing work. It keeps context, owns a role, works with people, and brings important decisions back to them.</p>
            <details className="build-details"><summary>Meet Juniper at Pilates Companion</summary><p>Pilates Companion shows the difference: it remembers a member’s goal and session history, prepares pre-class context for instructors, explains sourced progress, and carries approved guidance into the next visit.</p></details>
            <p className="build-card__disclosure">Private fictional demo · illustrative scene, not verified posture analysis or a client rollout.</p>
          </div>
        </article>
        <article className="build-card">
          <div className="build-card__visual"><img src="/showcase/reformer-camera-concept.svg" alt="Concept illustration of a Pilates reformer with a camera on a rear frame-mounted arm" loading="lazy" width={800} height={450} /></div>
          <div className="build-card__body">
            <h3>Smart devices</h3>
            <p>Connected cameras, sensors and software, built around your space.</p>
            <p className="build-card__detail">The physical setup and the software are considered together.</p>
            <p className="build-card__disclosure">Concept illustration · reformer-mounted camera. Not a real installation or a validated form-correction system.</p>
          </div>
        </article>
      </div>
    </div>
  </section>
);

export default React.memo(CustomBuilds);
